// extracted by mini-css-extract-plugin
export default {"bd":"index_bd_I3Yst","space40":"index_space40_Vz-XH","space10":"index_space10_GELDG"};